import { createI18n } from 'vue-i18n'
import vi from './locales/vi'
import en from './locales/en'
const savedLocale = typeof window !== 'undefined' ? window.localStorage?.getItem('qone.locale') : null
export const i18n = createI18n({ legacy: false, locale: savedLocale === 'en' ? 'en' : 'vi', fallbackLocale: 'en', messages: { vi, en } })
